var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Notification } from 'packages/notifications/Notification';
import PathBuilder from 'packages/core/PathBuilder';
import env from 'config/env.js';
var NotificationsRepository = /** @class */ (function (_super) {
    __extends(NotificationsRepository, _super);
    function NotificationsRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = '';
        _this.entity = Notification;
        _this.baseUrl = env.NOTIFICATIONS_API;
        _this.markReadPath = '/:uuid/mark-read';
        _this.markUnreadPath = '/:uuid/mark-unread';
        _this.markAllReadPath = '/mark-read';
        _this.slackMessage = '/slack';
        _this.sortDescending = { field: 'created_at', direction: 'desc' };
        return _this;
    }
    NotificationsRepository.prototype.list = function (cursor, limit) {
        if (limit === void 0) { limit = 50; }
        return this.getCursored(null, { id: cursor, limit: limit, sort: this.sortDescending });
    };
    NotificationsRepository.prototype.unreadMessages = function (cursoring) {
        var query = __assign({ read: 0, sort: this.sortDescending }, cursoring);
        return this.getCursored(null, query);
    };
    NotificationsRepository.prototype.markNotificationRead = function (uuid) {
        return this.axios.post(PathBuilder(this.markReadPath, { uuid: uuid }), null, { baseURL: this.baseUrl });
    };
    NotificationsRepository.prototype.markNotificationUnread = function (uuid) {
        return this.axios.post(PathBuilder(this.markUnreadPath, { uuid: uuid }), null, { baseURL: this.baseUrl });
    };
    NotificationsRepository.prototype.markAllRead = function () {
        return this.axios.post(this.markAllReadPath, null, { baseURL: this.baseUrl });
    };
    NotificationsRepository.prototype.sendSlackMessage = function (channelName, message) {
        return this.axios.post(this.slackMessage + "/" + channelName, null, { baseURL: this.baseUrl, params: { message: message } });
    };
    return NotificationsRepository;
}(AbstractRepository));
export { NotificationsRepository };
